/**
 * The signed-in lawyer's firm record, cached app-wide (the sidebar and the
 * assistant's badge read it). A firm-setting save that changes what they show
 * invalidates `lawFirmKey`.
 */
import { useQuery } from "@tanstack/react-query";

import { LawFirmsAPI } from "@/api/lawFirms";
import { queryClient } from "@/lib/query/queryClient";

export const lawFirmKey = (lawFirmId: string) =>
  ["law-firm", lawFirmId] as const;

export const useFirmRecord = (lawFirmId: string, enabled = true) =>
  useQuery(
    {
      queryKey: lawFirmKey(lawFirmId),
      queryFn: () => LawFirmsAPI.getById(lawFirmId),
      enabled: enabled && Boolean(lawFirmId),
      staleTime: 5 * 60_000
    },
    queryClient
  );
